<template>
  <div class="circle-checkbox" :class="{'checked': checked}">
    <transition name="zoom-fade">
      <icon-check v-if="checked"/>
    </transition>
  </div>
</template>

<script>
import IconCheck from "./Icon/IconCheck";
export default {
  components: {IconCheck},
  props: {
    checked: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss">
  .zoom-fade {
    &-enter-active, &-leave-active {
      transition: opacity 200ms, transform 200ms;
      will-change: transform;
    }
    &-enter, &-leave-to {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 1);
    }
    &-enter-to, &-leave {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }
  }

  .circle-checkbox {
    width: 0.24rem;
    height: 0.24rem;
    box-sizing: border-box;
    border: 1px solid rgba(57,75,229,1);
    border-radius: 50%;
    transition: background-color 200ms;
    background-color: rgba(255, 255, 255, 1);

    &.checked {
      background-color: rgba(57,75,229,1);
    }
  }
</style>
